<template>
  <div class="container d-flex flex-column justify-content-center align-items-center text-left py-5">
    <h1 class="mb-3">{{ $t('about.title') }}</h1>
    <p class="lead" style="max-width: 700px; white-space: pre-line;">
      {{ $t('about.content') }}
    </p>
  </div>
</template>

<script setup>

</script>